import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoundButton from 'features/shared/components/buttons/RoundButton';
import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import CommodityIcon from 'features/shared/components/icons/CommodityIcon';
import React from 'react';
import ContractSimplifiedDTO from '../dtos/ContractSimplifiedDTO';
import ContractStatusLabel from './ContractStatusLabel';
import { getStreetSection, getCitySection } from 'features/shared/helpers/AddressFormatter';
import { getContractDetailRoute } from 'features/shared/helpers/routeHelper';
import styles from "./contractSimplified.module.scss";
import { getTerminationDate } from 'features/shared/helpers/dateHelper';
import { useTranslation } from 'react-i18next';
interface Props {
  contract: ContractSimplifiedDTO;
}

const ContractSimplified = ({ contract }: Props) => {
  // translations
  const tTerms = useTranslation("shared\\terms").t;

  // private props
  const streetSection = getStreetSection(contract.contractEnergy?.placeOfDeliveryAddress);

  // sub-renders
  const renderSignatureDate = () => {
    if (contract.signitureDate) {
      return (
        <span className="mt-lg-n1">
          <span className="mr-1 text-muted">
            <FontAwesomeIcon icon="file-signature" size="xs" fixedWidth />
          </span>
          <span className="small">
            <DateFormatter date={contract.signitureDate} />
          </span>
        </span>
      );
    } 
  }

  const renderTerminationDate = () => {
    if (contract.terminationDatePresentation) {
      return (
        <span className="mt-lg-n1">
          <span className="mr-1 text-muted">
            <FontAwesomeIcon icon="calendar-times" size="xs" fixedWidth />
          </span>
          <span className="small">
            {getTerminationDate(contract, tTerms)}
          </span>
        </span>
      );
    } 
  }

  const renderEffectiveDate = () => { 
    return (
      <span className="mr-2 mr-lg-0">
        <span className="mr-1 text-muted">
          <FontAwesomeIcon icon="calendar-check" size="xs" fixedWidth />
        </span>
        <span className="small">
          <DateFormatter date={contract.effectiveDate!} />
        </span>
      </span>
    );
  }  

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-lg-5 pr-lg-3 pr-xl-0">
            <div className="row no-gutters align-items-center">
              <div className="col-auto col-lg-8 col-xl-7 pr-lg-3">
                <div className="d-flex">
                  <CommodityIcon commodityDetail={contract.commodityDetail!} includeColor isProduction={contract.isProduction} />
                  <div className="ml-2 text-truncate" title={contract.namedByCustomer}>
                    {contract.namedByCustomer}
                  </div>
                  <div className="d-lg-none mx-2 my-1 border-right border-dark"></div>
                </div>
              </div>
              <div className="col col-lg-4 col-xl-5">
                <div className="text-muted text-truncate" title={contract.contractNumber}>
                  {contract.contractNumber}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-xl-4 pr-xl-3 ">
            <div className={`d-sm-flex flex-wrap ${styles.addressItem}`}>     
              {streetSection && streetSection !== " " && //TODO: Lepe bez kontroly mezery
                <span className={`mr-1 ${styles.addressSection}`}>{streetSection},</span>                     
              }                       
              <span className={styles.addressSection}>{getCitySection(contract.contractEnergy?.placeOfDeliveryAddress)}</span>
            </div>
          </div>
          <div className="col-lg-4 col-xl-3">
            <div className="row no-gutters align-items-center">
              <div className="col col-lg-7 col-xl-8 order-1 pl-2 pl-lg-3 pl-xl-0">
                <div className="d-flex flex-wrap flex-lg-column">
                  {renderSignatureDate()}
                  {renderEffectiveDate()}
                  {renderTerminationDate()}
                </div>
              </div>  
              <div className="col-auto order-0 order-lg-1 col-lg-5 col-xl-4 text-lg-center text-xl-left">
                <ContractStatusLabel status={contract.contractStatus!} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-auto pl-2 pl-sm-3">
        <RoundButton 
          to={getContractDetailRoute(contract.contractId!)} 
          asLink 
        />
      </div>
    </div>
  )
}

export default ContractSimplified;
